module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAYCAYAAAD6S912AAAAAXNSR0IArs4c6QAAALBJREFUSEvN1TEOQiEMBmB/72biqgsDi5OXMiaOUBNv4uJFvECh5jkXaPENdmzJF5b2x0YpItrXWm8AXswcYoxv7Z3Wg9bMOT9E5LDMADyZeWdFVTCldBSRO4CtF1XBBSGiUynl6kWb4CzaBWfQIehFTaAHNYNW1AVaUDc4QqfABnoJIZz/A+xtkfuHo5V0gSPse0isd86CmUErZgI92BD0Yl1wBmuCq0fA6iH1S4x+ANV9GCgdpXYeAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/index/right.png
// module id = yJl/
// module chunks = 1